import React from 'react';
import PropTypes from 'prop-types';
import ResourceForm from "components/forms/ResourceForm";
import AutoSaveComponents from "components/forms/Component Sets/AutoSaveComponents";
import BasicComponents from "components/forms/Component Sets/BasicFormComponents";
import UnvalidatedBasicComponents from 'components/forms/Component Sets/UnvalidatedBasicFormComponents';

/**
 * Creates a function that takes a form config to return a ResourceForm component.
 * @param components
 * @return {function(*)}
 */
export const makeFormFactory = (components) => {
    return (config) => {
        let comp = (props) => <ResourceForm components={components}
                                            onValueChanged={props.onValueChanged}
                                            onValidationError={props.onValidationError}
                                            config={config}
                                            errors={props.errors}
                                            resource={props.data}/>;
        comp.propTypes = {
            onValueChanged: PropTypes.func.isRequired,
            fieldProps: PropTypes.func,
            sectionProps: PropTypes.func,
            data: PropTypes.object.isRequired
        };

        return comp;
    };
};

/**
 * Creates a ResourceForm component injected that will use the AutoSaveComponents
 * @type {function(*)}
 */
export const autoSaveForm = makeFormFactory(AutoSaveComponents);

/**
 * Creates a ResourceForm component injected that will use the BasicComponents
 * @type {function(*)}
 */
export const basicForm = makeFormFactory(BasicComponents);

/**
 * Creates a ResourceForm component injected that will use the UnvalidatedBasicComponents
 * @type {function(*)}
 */
export const unvalidatedBasicForm = makeFormFactory(UnvalidatedBasicComponents);



// WEBPACK FOOTER //
// ./public/utils/helpers.js